import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { OnSiteMovementEditCompletePage } from './on-site-movement-edit-complete';
import { DirectivesModule } from '../../../directives/directives.module';

@NgModule({
  declarations: [
    OnSiteMovementEditCompletePage,
  ],
  imports: [
    IonicPageModule.forChild(OnSiteMovementEditCompletePage),
    DirectivesModule,
  ],
})
export class OnSiteMovementEditCompletePageModule {
}



// WEBPACK FOOTER //
// ./src/pages/on-site-movement/on-site-movement-edit-complete/on-site-movement-edit-complete.module.ts